module.exports = __webpack_public_path__ + "media/landing_750x800-v2.7d72c302.mp4";